module.exports = __webpack_public_path__ + "static/img/056.5efc9ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/yqs/056.png
// module id = e1QQ
// module chunks = 0